import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, inject, input, viewChild } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatPrefix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { Router } from '@angular/router';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';
import { IconComponent } from '@teamfoster/sdk/icon';
import { debounceTime, distinctUntilChanged } from 'rxjs';

@Component({
    selector: 'app-search-field',
    imports: [MatFormField, ReactiveFormsModule, FormsModule, MatInput, IconComponent, MatPrefix, FromDictionaryPipe],
    templateUrl: './search-field.component.html',
    styleUrl: './search-field.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchFieldComponent implements AfterViewInit {
  initialQuery = input<string>('');

  fb = inject(FormBuilder);
  router = inject(Router);
  cd = inject(ChangeDetectorRef);

  field = viewChild<ElementRef<HTMLInputElement>>('input');

  searchForm = this.fb.group({
    query: this.fb.control<string>(''),
  });

  ngAfterViewInit(): void {
    this.searchForm.patchValue({ query: this.initialQuery() });
    this.field()?.nativeElement.focus();
    this.cd.detectChanges();
  }

  onSubmit(): void {
    this.router.navigate(['/zoeken'], { queryParams: { q: this.searchForm?.value?.query } });
  }
}
